"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookiesConsentBasicModal = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const BasicModalView_1 = require("./views/BasicModalView");
function CookiesConsentBasicModal({ className, }) {
    const [displaySettings, setDisplaySettings] = (0, react_1.useState)(false);
    const [cookieValue, setCookieValue] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        setCookieValue((0, app_1.getCookie)(app_1.COOKIE_CONSENT));
        (0, app_1.activateScripts)();
    }, []);
    const setCookieLocal = (data) => {
        const stringified = Object.entries(data)
            .reduce((acc, [key, value]) => {
            if (value) {
                acc.push(key);
            }
            return acc;
        }, [])
            .join(',');
        setCookieValue(stringified);
        (0, app_1.setCookie)(app_1.COOKIE_CONSENT, stringified);
        (0, app_1.activateScripts)();
    };
    if (typeof cookieValue === 'string') {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(BasicModalView_1.BasicModalView, { open: displaySettings, setValue: setCookieLocal }), displaySettings ? null : ((0, jsx_runtime_1.jsx)(BasicModalView_1.BasicModelViewFloat, { className: className, openSettings: () => setDisplaySettings(true), setValue: setCookieLocal }))] }));
}
exports.CookiesConsentBasicModal = CookiesConsentBasicModal;
